// extracted by mini-css-extract-plugin
export default {"dataList":"TBtGFT5INIot5sEUIm8w","loadingSlot":"FgEUt_kRHRTXSTPCORUT","dataListFooter":"wjue60N7etC82d435zNx","common_bganimation":"VZHfx3KBObVSyTJ1Y4jA"};